import { StyleSheet } from 'react-native';
import { FontFamily } from '../../../constants/fonts';

export const locationSummaryTableStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D7E5F8',
    overflow: 'hidden',
  },
  tableScroll: {
    width: '100%',
  },
  tableContent: {
    minWidth: 1240,
    flexGrow: 1,
  },
  tableInner: {
    minWidth: 1240,
    width: '100%',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'transparent',
    minHeight: 48,
    borderBottomWidth: 2,
    borderBottomColor: '#D7E5F8',
  },
  headerCell: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: 10,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRightWidth: 0,
  },
  headerText: {
    fontSize: 12,
    color: '#616161',
    fontFamily: FontFamily.bold,
    textTransform: 'uppercase',
    lineHeight: 18,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 60,
    borderBottomWidth: 2,
    borderBottomColor: '#D7E5F8',
    backgroundColor: '#FFFFFF',
  },
  rowAlt: {
    backgroundColor: '#FFFFFF',
  },
  cell: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRightWidth: 0,
    justifyContent: 'center',
  },
  rowLabelWrap: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowLabel: {
    fontSize: 12,
    color: '#3A3A3A',
    fontFamily: FontFamily.medium,
  },
  rowLabelStrong: {
    fontFamily: FontFamily.bold,
  },
  rowValue: {
    fontSize: 12,
    color: '#3A3A3A',
    fontFamily: FontFamily.regular,
  },
  expandIconButton: {
    width: 16,
    height: 16,
    marginRight: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  weekHint: {
    fontSize: 12,
    color: '#9CA3AF',
    fontFamily: FontFamily.regular,
    lineHeight: 14,
  },
  executionWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 8,
  },
  executionBarTrack: {
    width: 80,
    height: 8,
    backgroundColor: '#E6E6E6',
    borderRadius: 4,
    overflow: 'hidden',
  },
  executionBarFill: {
    height: '100%',
    backgroundColor: '#C12C01',
    borderRadius: 4,
  },
  executionValue: {
    color: '#C12C01',
    fontSize: 12,
    fontFamily: FontFamily.bold,
  },
  emptyState: {
    padding: 24,
    alignItems: 'center',
  },
  emptyStateText: {
    color: '#6B7280',
    fontSize: 13,
    fontFamily: FontFamily.medium,
  },
});
